import { motion } from "framer-motion";
import { Link2, Tag, Banknote } from "lucide-react";

export default function LandingHowItWorks() {
  const steps = [
    {
      icon: Link2,
      title: "Connect",
      description: "Link your Telegram channel, Discord server, or Slack workspace in just 1 click.",
      color: "text-text-primary",
    },
    {
      icon: Tag,
      title: "Price",
      description: "Set up recurring subscription plans and generate instant payment links.",
      color: "text-golden-accent",
    },
    {
      icon: Banknote,
      title: "Earn",
      description: "Subscribers pay via Razorpay. SuBs grants access and manages renewals entirely on autopilot.",
      color: "text-functional-success",
    },
  ];

  return (
    <section id="how-it-works" className="relative py-24 bg-dark-primary text-center">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <motion.div
           initial={{ opacity: 0, y: 20 }}
           whileInView={{ opacity: 1, y: 0 }}
           viewport={{ once: true }}
           className="mb-20"
        >
          <h2 className="text-4xl md:text-6xl font-extrabold font-outfit text-text-primary uppercase tracking-tight leading-tight">
            Three Steps to <br/>
            <span className="text-golden-accent">Revenue</span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-12 relative">
           {/* Connecting Line (Desktop) */}
           <div className="hidden md:block absolute top-[2rem] left-[15%] right-[15%] h-px bg-dark-border z-0" />

           {steps.map((step, i) => (
            <motion.div
              key={step.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.15 }}
              className="relative z-10 flex flex-col items-center group"
            >
              <div className="w-16 h-16 rounded-full bg-dark-secondary border border-dark-border flex items-center justify-center mb-8 shadow-xl transition-transform group-hover:scale-110 group-hover:border-golden-accent/50">
                 <step.icon size={28} className={step.color} strokeWidth={1.5} />
              </div>
              
              <h3 className="text-2xl font-bold font-outfit text-text-primary mb-3">
                {step.title}
              </h3>
              <p className="text-lg text-text-secondary font-light max-w-xs mx-auto leading-relaxed">
                {step.description}
              </p>
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
}
